/* @ts-ignore */
import * as Types from '../generated/graphql.g';

import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';

function fetcher<TData, TVariables>(query: TypedDocumentString<unknown, unknown>, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(import.meta.env.VITE_API_URL_GRAPHQL as string, {
    method: "POST",
    ...({"credentials":"include","headers":{"Content-Type":"application/json"}}),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
export type ClientApplicationSearchResultFragment = { __typename: 'ClientApplicationType', id: string, resource: { __typename: 'ApplicationResourceType', id: string, resourceGroup?: { __typename: 'TenantedResourceGroupType', id: string } | null }, client: { __typename: 'ClientType', id: string, name: string } };

export type GlobalSearchQueryVariables = Types.Exact<{
  search: Types.Scalars['String']['input'];
  clientId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
  isClientScoped: Types.Scalars['Boolean']['input'];
}>;


export type GlobalSearchQuery = { __typename: 'Query', clients?: { __typename: 'ClientTypeConnection', edges: Array<{ __typename: 'ClientTypeEdge', node?: { __typename: 'ClientType', id: string, name: string, domain: string } | null } | null> } | null, users?: { __typename: 'UserTypeConnection', edges: Array<{ __typename: 'UserTypeEdge', node?: { __typename: 'UserType', id: string, name: string, email: string } | null } | null> } | null, clientEmployees?: { __typename: 'ClientEmployeeTypeConnection', edges: Array<{ __typename: 'ClientEmployeeTypeEdge', node?: { __typename: 'ClientEmployeeType', id: string, name: string, email: string, client: { __typename: 'ClientType', id: string, name: string } } | null } | null> } | null, resources?: { __typename: 'ResourceTypeConnection', edges: Array<{ __typename: 'ResourceTypeEdge', node?: { __typename: 'ResourceType', id: string, productName?: string | null, vendorName?: string | null, productDomainName?: string | null, signedLogoUrl?: string | null } | null } | null> } | null, applicationResources?: { __typename: 'ApplicationResourceTypeConnection', edges: Array<{ __typename: 'ApplicationResourceTypeEdge', node?: { __typename: 'ApplicationResourceType', id: string, vendorDomainName?: string | null, productDomainName?: string | null, vendorName?: string | null, vendorDescription?: string | null, productName?: string | null, productDescription?: string | null, key?: string | null, publicResource: { __typename: 'ResourceType', signedLogoUrl?: string | null }, applications?: { __typename: 'ClientApplicationTypeConnection', edges: Array<{ __typename: 'ClientApplicationTypeEdge', node?: { __typename: 'ClientApplicationType', id: string, resource: { __typename: 'ApplicationResourceType', id: string, resourceGroup?: { __typename: 'TenantedResourceGroupType', id: string } | null }, client: { __typename: 'ClientType', id: string, name: string } } | null } | null> } | null } | null } | null> } | null };


export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}
export const ClientApplicationSearchResultFragmentDoc = new TypedDocumentString(`
    fragment ClientApplicationSearchResult on ClientApplicationType {
  id
  resource {
    id
    resourceGroup {
      id
    }
  }
  client {
    id
    name
  }
}
    `, {"fragmentName":"ClientApplicationSearchResult"});
export const GlobalSearchDocument = new TypedDocumentString(`
    query GlobalSearch($search: String!, $clientId: UUID, $isClientScoped: Boolean!) {
  clients(name_Icontains: $search, first: 3) @skip(if: $isClientScoped) {
    edges {
      node {
        id
        name
        domain
      }
    }
  }
  users(name_Icontains: $search, first: 3) @skip(if: $isClientScoped) {
    edges {
      node {
        id
        name
        email
      }
    }
  }
  clientEmployees(name_Icontains: $search, first: 3, clientId: $clientId) {
    edges {
      node {
        id
        name
        email
        client {
          id
          name
        }
      }
    }
  }
  resources(search: $search, first: 3, isPrimaryResource: true, isVisible: true) @skip(if: $isClientScoped) {
    edges {
      node {
        id
        productName
        vendorName
        productDomainName
        signedLogoUrl
      }
    }
  }
  applicationResources(
    search: $search
    first: 3
    isPrimaryResource: true
    isSaas: true
    isVisible: true
    clientId: $clientId
  ) {
    edges {
      node {
        id
        vendorDomainName
        productDomainName
        vendorName
        vendorDescription
        productName
        productDescription
        key
        publicResource {
          signedLogoUrl
        }
        applications(clientId: $clientId) {
          edges {
            node {
              ...ClientApplicationSearchResult
            }
          }
        }
      }
    }
  }
}
    fragment ClientApplicationSearchResult on ClientApplicationType {
  id
  resource {
    id
    resourceGroup {
      id
    }
  }
  client {
    id
    name
  }
}`);

export const useGlobalSearchQuery = <
      TData = GlobalSearchQuery,
      TError = unknown
    >(
      variables: GlobalSearchQueryVariables,
      options?: Omit<UseQueryOptions<GlobalSearchQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GlobalSearchQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GlobalSearchQuery, TError, TData>(
      {
    queryKey: ['GlobalSearch', variables],
    queryFn: fetcher<GlobalSearchQuery, GlobalSearchQueryVariables>(GlobalSearchDocument, variables),
    ...options
  }
    )};

useGlobalSearchQuery.getKey = (variables: GlobalSearchQueryVariables) => ['GlobalSearch', variables];

export const useInfiniteGlobalSearchQuery = <
      TData = InfiniteData<GlobalSearchQuery>,
      TError = unknown
    >(
      variables: GlobalSearchQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GlobalSearchQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GlobalSearchQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GlobalSearchQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GlobalSearch.infinite', variables],
      queryFn: (metaData) => fetcher<GlobalSearchQuery, GlobalSearchQueryVariables>(GlobalSearchDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGlobalSearchQuery.getKey = (variables: GlobalSearchQueryVariables) => ['GlobalSearch.infinite', variables];


useGlobalSearchQuery.fetcher = (variables: GlobalSearchQueryVariables) => fetcher<GlobalSearchQuery, GlobalSearchQueryVariables>(GlobalSearchDocument, variables);
